import { canRenderAsRichText, RICH_TEXT_FEATURES, type RichTextConfig } from '@/shared/components';
import { TEMPLATE_LINK_POLICY } from './linkUri';
import { PLACEHOLDER_PATTERN } from './placeholders';

export const TEMPLATE_EDITOR_CONFIG: RichTextConfig = {
  features: RICH_TEXT_FEATURES,
  linkPolicy: TEMPLATE_LINK_POLICY,
  placeholderPattern: PLACEHOLDER_PATTERN,
};

export const canEditVisually = (html: string): boolean => canRenderAsRichText(html, TEMPLATE_EDITOR_CONFIG);
